export default "__VITE_ASSET__EOMD3DDi__"